<template>
  <div>
    <EstimateForm :estimate="estimate" :segment-configurations-factory="createSegmentConfiguration"/>
  </div>
</template>

<script lang="ts">
import {PredictEstimateState as EstimateState} from '@/model/api';
import PredictEstimate from '@/model/estimates/PredictEstimate';
import {HttpClient} from '@/model/http';
import {NotSubmittedParameters, OfflineManager, StagedParameters} from '@/model/offline';
import {StoredParameters} from '@/model/offline/storage/StoredParameters';
import {defineComponent, PropType, provide} from 'vue';
import {useI18n} from 'vue-i18n';
import EstimateForm from './common/EstimateForm.vue';
import PhotosSegment from './common/PhotosSegment.vue';
import {LocationSegment, ParametersSegment, SegmentConfiguration} from './common/segments';

export default defineComponent({
    components: {EstimateForm},
    props: {
        estimate: {
            type: Object as PropType<EstimateState>,
            required: true,
        },
    },
    setup(props) {
        const {t} = useI18n();

        const notSubmittedParameters = new NotSubmittedParameters(
            new StoredParameters(
                props.estimate.id,
                NotSubmittedParameters.STORAGE_KEY,
            ),
        );

        const model = new PredictEstimate(props.estimate, new HttpClient());

        const offlineManager = new OfflineManager<EstimateState>(
            new StagedParameters(
                new StoredParameters(
                    props.estimate.id,
                    StagedParameters.STORAGE_KEY,
                ),
            ),
            model,
        );

        provide('notSubmittedParameters', notSubmittedParameters);
        provide('model', model);
        provide('offlineManager', offlineManager);

        function createSegmentConfiguration(estimate: EstimateState): SegmentConfiguration[] {
            return [
                {
                    label: t('form.segments.location'),
                    path: '/adresa',
                    component: LocationSegment,
                    props: {defaultValue: estimate.location},
                },
                ...estimate.segments.map(segment => ({
                    label: segment.label,
                    path: '/' + segment.path,
                    component: ParametersSegment,
                    props: {
                        parameters: Object.fromEntries(
                            Object.entries(estimate.parameters)
                                .filter(([parameterName]) => segment.parameterNames.includes(parameterName)),
                        ),
                        stagedParameters: offlineManager.stagedParameters,
                        notSubmittedParameters,
                    },
                })),
                {
                    label: t('form.segments.photos'),
                    path: '/fotografie',
                    component: PhotosSegment,
                    props: {photos: estimate.photos, estimate},
                },
            ];
        }

        return {
            createSegmentConfiguration,
        };
    },
});
</script>
